import type { CreditPlanId } from "@/lib/payments/plans";
import { formatFreePreviewCountLabel } from "@/lib/payments/free-preview-config";

/** Shown once below the pricing grid — not repeated on every card. */
export const SHARED_PACK_INCLUDES = [
  "Full wheel catalog (100+)",
  "Custom wheel uploads",
  "HD downloads, no watermark",
  "Credits never expire",
] as const;

/** One-line differentiator per tier — the only copy that varies by card. */
export const PACK_TAGLINES: Partial<Record<CreditPlanId, string>> = {
  free: `${formatFreePreviewCountLabel()} to test the workflow`,
  mini: "A small pack to try a few wheel options",
  basic: "Enough previews to compare a few setups",
  starter: "Sweet spot for enthusiasts & buyers",
  pro: "For builds that need many comparisons",
  power: "High volume for dealers & shops",
  trial: "One-time try before committing",
};

export function getPackTagline(planId: CreditPlanId, fallbackDescription: string): string {
  return PACK_TAGLINES[planId] ?? fallbackDescription;
}

export function formatPriceUsd(priceUsd: number): { dollars: string; cents: string } {
  const [dollars, cents = "00"] = priceUsd.toFixed(2).split(".");
  return { dollars, cents };
}
